import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import Row from '~/layout/Row';
import Column from '~/layout/Column';

import Spinner from '~/components/Spinner';
import Modal from '~/components/base/Modal';
import Button from '~/components/base/Button';

import useGarage from '~/account/hooks/useGarage';

import ModalCard from '~/components/modal/ModalCard';

import { h2 } from '~/styles/typography';

const StyledButton = styled(Button)`
    width: 100%;
`;

const ModalTitle = styled.h2`
    ${h2};
    color: ${({ theme }) => theme.colors.primary.red};

    @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
        margin-bottom: 45px;
    }
`;

const AddWashModal = ({ open, setOpen }) => {
    const { allVehicles, loading } = useGarage();
    const vehiclesWithSubscriptions = allVehicles.filter(
        ({ subscription }) => subscription
    );

    return (
        <Modal open={open} setOpen={setOpen}>
            <Row>
                <Column span={12}>
                    <ModalTitle>Select a car:</ModalTitle>
                </Column>
                {loading ? (
                    <Spinner />
                ) : vehiclesWithSubscriptions.length ? (
                    vehiclesWithSubscriptions.map(
                        ({ vehicle, subscription }) => (
                            <Column key={vehicle.id} span={12} spanTablet={6}>
                                <ModalCard
                                    title={`${vehicle.make} ${vehicle.model}`}
                                    description={vehicle.license_plate_number}
                                    inputType="radio"
                                    inputName="vehicle"
                                    chipText={subscription.plan.name}
                                    image={vehicle.images[0].url}
                                />
                            </Column>
                        )
                    )
                ) : null}
                <Column span={12}>
                    <StyledButton buttonSize="large">Continue</StyledButton>
                </Column>
            </Row>
        </Modal>
    );
};

AddWashModal.propTypes = {
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired
};

export default AddWashModal;
